import Avatar from '@mui/material/Avatar'

import { base64LennarPLRImg } from '../Home/LennarPLRLogo'

export function LennarLogoComponent() {
  return (
    <Avatar
      src={base64LennarPLRImg}
      sx={{
        bgcolor: 'transparent',
        height: 53,
        verticalAlign: 'middle',
        width: 80,
      }}
      variant="square"
      alt="Lennar PLR Logo"
    />
  )
}
